import './devmod.config'; // Must be first!

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as ChartJSConfig from './app/chartjs.config';
import { environment } from './environments/environment';
import 'hammerjs';
import { LoopBackConfig } from '@careapp/angular-sdk';
require('chart.js');

ChartJSConfig.configureTooltips();

if (environment.production) {
  enableProdMode();
}

LoopBackConfig.setBaseURL(environment.API_BASE_URL);
LoopBackConfig.setApiVersion(environment.API_VERSION);

platformBrowserDynamic().bootstrapModule(AppModule);
